import React, { useState, useEffect } from 'react'


function VfSearchInput({ type,
    inputHandler,
    placeholder,
    error,
    value,
    isDisable,
    color,
    onSearch,
    icon,
    id, required, label, showLabel, optional }) {
    const [showPassword, setshowPassword] = useState(false)
    const style = {
        inputContainer: {
            paddingLeft:5,
            // padding: 2,
            overflow: "hidden",
            width: "100%",
            outline: "none",
            border: error ? "2px solid #f00" : "2.5px solid var(--primary)",
            borderRadius: "10px",
            height: 47,
            transition: "all .3s ease-in-out",
            background: '#fff'
        },
        input: {
            outline: "none",
            border: "none",
            width: '90%',
        },
        icon: {
            height: 47,
            width: '15%',
            cursor: "pointer",
            height: '100%',
            color: 'var(--primary)',
            opacity: 0.9,
            // background: '#d1d2d2',
            boxShadow:'0 0 15px rgb(0 0 0 / 20%)'
        },
        label: {
            color: color === "secondary" ? "#fff" : 'var(--primary)',
            fontWeight: 700,
            opacity: 0.7
        }
    };
    return (
        <div className="my-2 w-100">
            {
                showLabel &&
                <div style={style.label} className="my-1 ms-2">
                    <div className="d-inline-block pg-text__bold ">{label}</div>
                    {required && <span className="textc-primary fst-italic"> (Required)</span>}
                    {optional && !isDisable && <span className="textc-primary fst-italic"> (Optional)</span>}
                </div>
            }
            <div >
                <div
                    className="d-flex flex-row"
                    style={style.inputContainer}
                >
                    <input
                        placeholder={placeholder}
                        type={showPassword ? "text" : type}
                        style={style.input}
                        onInput={inputHandler}
                        value={value}
                        disabled={isDisable}
                        id={id}
                    />
                    {icon && <div className="d-inline-block mx-auto fs-3 p-1 my-auto text-center" style={style.icon} onClick={onSearch}>
                        {icon}
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default VfSearchInput
